import * as Sentry from '@sentry/react'

const dsn = import.meta.env.VITE_SENTRY_DSN
const apiUrl = import.meta.env.VITE_API_URL
const environment = import.meta.env.VITE_APP_ENV ?? 'local'

if (dsn && environment !== 'local') {
  Sentry.init({
    dsn,
    environment,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    tracePropagationTargets: ['localhost', ...(apiUrl ? [apiUrl] : [])],
  })
}
